import { EAreaDimensionType, updateAreaDimension } from '@/editor/data/dimension/dimension';
import { AreaDimensionTextInfoEntity } from '@/editor/entities/areaDimensionTextInfoEntity';
import { IPoint2d } from '@/editor/math/IPoint2d';
import { getUniqueId } from '@/editor/utils';

const VIRTUAL_ID = 'area_dimension_text_info_virtual';

/** 绘制矩形面积标注 OR 拖动面积标注时的中间状态文本，由控制器直接持有 */
export class VirtualAreaDimensionTextInfo {
  private _entity: AreaDimensionTextInfoEntity | null = null;

  update(points: IPoint2d[], options: { selected?: boolean } = {}) {
    if (points.length < 3) {
      this.clear();
      return;
    }

    const polygon = points.map((point) => ({ ...point, id: 'id' in point ? (point.id as string) : getUniqueId() }));
    const { area, labelPosition, points: dimensionPoints } = updateAreaDimension(polygon);
    if (area === undefined || !labelPosition || !dimensionPoints) {
      this.clear();
      return;
    }
    const data = {
      id: VIRTUAL_ID,
      type: EAreaDimensionType.RECT, // 这里没有意义
      area: area,
      labelPosition: labelPosition,
      points: dimensionPoints
    };

    if (this._entity) {
      this._entity.update(data);
    } else {
      this._entity = new AreaDimensionTextInfoEntity(data);
    }
    if (options.selected) this._entity.setSelected(true);
    this._entity.updatePosition();
  }

  clear() {
    this._entity?.dispose();
    this._entity = null;
  }

  dispose() {
    this.clear();
  }
}
